import React from 'react';
import ReactDOM from "react-dom/client";
import MapComponent from './MapComponent';
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaRegCheckCircle, FaMapMarkerAlt } from 'react-icons/fa';
import MosulMap from './MosulMap';
const locations = [
    { name: 'Point A', latitude: 51.505, longitude: -0.09 },
    { name: 'Point B', latitude: 51.515, longitude: -0.1 },
];
const Mosul = () =>{
    return(
        <section id="map" className=" myMap map features">
                <h2 className="features-heading"> <span>:</span>تتوفر عدساتنا في المتاجر التالية </h2>
                <div className="feature-cards">
                  {[
                    { title: 'الجامعة للبصريات', desc: 'الموصل - الجانب الايسر - قرب نفق الجامعة', side:'right' },
                    { title: 'الفا للبصريات', desc: 'الموصل - الجانب الايسر - المصارف ' ,side:'left'},
                    { title: 'بغداد للبصريات', desc: 'الموصل - الجانب الايسر - حي المصارف - قرب التقاطع', side:'right' },
                    { title: 'الريان للبصريات', desc: 'الموصل - الجانب الايسر - المصارف ', side: 'left' },
                    { title: 'الرؤية الجديدة للبصريات', desc: 'الموصل - الجانب الايسر -المصارف    ', side:'right' },
                    { title: 'نظرة للبصريات', desc: 'الموصل - الجانب الايسر - حي الغفران - قرب صيدلية فيتامين ', side: 'left' },
                    { title: 'مركز الحدباء التخصصي', desc: 'الموصل - الجانب الايسر - القادسية - قرب دورة حاملة الجرار', side: 'left' },
                    { title: 'الزرقاء للبصريات', desc: 'الموصل - الجانب الايسر - المصارف ', side: 'right' },
                    { title: 'زيد للبصريات', desc: 'الموصل - الجانب الايسر - المصارف - قرب اثاث استقبال', side:'left' },
        
                    { title: 'ابن الهيثم للبصريات', desc: 'الموصل - الجانب الايسر - الزهور - قرب دورة سيدتي الجميلة', side:'right' },
                    { title: 'اليمامة للبصريات', desc: 'الموصل - الجانب الايسر - المثنى - قرب دورةالمثنى ', side: 'left' },
                    { title: 'المصارف للبصريات', desc: 'الموصل - الجانب الايسر - المصارف    ', side: 'right' },
                    { title: 'عوينات مستشفى الحياة', desc: 'الموصل - حي الضباط - مستشفى الحياة الدولي - الطابق الخامس ', side: 'left' },
                    { title: 'الكحال للبصريات', desc: 'الموصل - الجانب الايمن - حي الشفاء - قرب دورة المستشفى ', side: 'left' },


                  ].map((feature, index) => (
                    <div key={index} className={`dark-cards feature-card ${feature.side}`}>
                      <h4><FaMapMarkerAlt className="check-icon" size={20} />
        {feature.title}             
        </h4>
                      <p>{feature.desc}</p>
                    </div>
                  ))}
        
        </div>
        
                <MosulMap locations={locations} />
        </section>
    )
}

export default Mosul
